import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import { userConstants } from '../constants'
import geoReducers from './geo.reducers'
import userReducers from './user.reducers'
import claimReducers from './claim.reducers'
import myRewardsReducer from './myRewards'
import uplayReducer from './uplay.reducers'
import steamReducer from './steam.reducers'
import epicReducer from './epic.reducers'
import rcReducer from './rc.reducers'
import amd50Reducer from './amd50.reducers'
import faqReducer from './faq.reducers'
import supportReducer from './support.reducers'
import specialPromotionReducer from './specialPromotion.reducers'

const appReducer = combineReducers({
  form: formReducer,
  geoReducers,
  uplayReducer,
  steamReducer,
  epicReducer,
  rcReducer,
  userReducers,
  claimReducers,
  myRewardsReducer,
  amd50Reducer,
  faqReducer,
  supportReducer,
  specialPromotionReducer,
})

const rootReducer = (state, action) => {
  if (
    action &&
    (action.type === userConstants.LOGOUT || action.type === userConstants.SESSION_USER_FAILURE)
  ) {
    const preservedState = state && state.geoReducers ? { geoReducers: state.geoReducers } : {}
    return appReducer(preservedState, action)
  }
  return appReducer(state, action)
}

export default rootReducer
